import { useStore } from 'vuex';

export default function useInitializeAddToBasketContext()
{
    const store = useStore();

    /**
     * Prepare an empty list of basket lines to be added to the basket, along
     * with an optional dependency code to link them together.
     */
    class InitializeAddToBasketContext
    {
        async handle()
        {
            return await store.dispatch('basket/resetAddToBasketContext');
        }
    }

    return InitializeAddToBasketContext;
}
